export const ROVO_AGENTS_FE_TEAM_NAME = 'rovo-agents-fe';
